import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import { useFormik } from "formik";
import React, { useEffect, useMemo, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-quill/dist/quill.snow.css";
import "react-toastify/dist/ReactToastify.css";
import DatePicker, { registerLocale } from "react-datepicker";
import {
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Progress,
  Row,
  Spinner,
} from "reactstrap";
import * as Yup from "yup";

//import images
// import {
//   getBarDetail,
//   postBarInformation,
//   putBarInformation,
// } from "store/bar-list/thunk";

import DropdownStatusNew from "components/Common/DropdownStatusNew";

import {
  COLOR_AUDITION_STATUS,
  LIST_OPTION_AUDITION_STATUS,
} from "helpers/constans";
import userApi from "api/userApi";
import ResourceFormArray from "components/Common/ResourceFormArray";
import AuditionRoleFormArray from "components/Common/AuditionRoleFormArray";
import ContentDetailFormArray from "components/Common/ContentDetailFormArray";
import UploadImage from "components/Common/UploadImage";
import { useSelector } from "react-redux";
import fieldsApi from "api/fieldsApi";
import { toast } from "react-toastify";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import auditionApi from "api/auditionApi";
import { formatDateStringToKorea, formatISOString } from "helpers/format";
import ModalConfirm from "components/Common/ModalConfirm";
import { useProfile, useRole } from "components/Hooks/UserHooks";

export interface Props {
  id?: string;
  isCopy?: boolean;
  triggerRefresh?: () => void;
  LIST_OPTION_ROLE?: any[];
  isShowDetail?: boolean;
  setLinkImage?: any;
  setIsOpen?: any;
  setItemToEdit?: any;
  loadTableData?: any;
}

registerLocale("en", en);
registerLocale("ko", ko);

const AuditionForm = ({
  id = "",
  triggerRefresh,
  LIST_OPTION_ROLE = [],
  isShowDetail = false,
  setLinkImage,
  setIsOpen,
  setItemToEdit,
  loadTableData,
}: Props) => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();
  const { userProfile } = useProfile();

  const companies: any = useSelector(
    (state: any) => state?.Company?.companies?.items
  );
  const [isOpenConfirm, setIsOpenConfirm] = useState<any>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingDetail, setIsLoadingDetail] = useState<boolean>(false);
  const [categories, setCategories] = useState<any>([]);
  const COMPANIES = useMemo(() => {
    return companies?.map((item: any) => ({
      label: item?.name,
      value: item?.id,
    }));
  }, [companies]);

  const onCloseConfirmClick = () => {
    setIsOpenConfirm(false);
  };

  const handleConfirmCategory = () => {
    const temp = categories?.find((item: any) => item?.id == isOpenConfirm);
    const role_groups = temp?.role_groups?.map((item: any) => ({
      ...item,
      label: item?.title,
      value: item?.id,
    }));

    formik.setFieldValue("role_group", role_groups || []);
    formik.setFieldValue("category", isOpenConfirm);
    formik.setFieldValue("audition_role", [
      {
        idx: 1,
        group: "",
        field_role_group_id: "",
        quantity: "",
        isDetail: false,
        role_detail: [],
      },
    ]);
    setIsOpenConfirm(false);
  };

  const handleSubmit = async (values: any) => {
    console.log("values", values);
    const sections =
      values?.content?.map((item: any) => ({
        is_active: !!item?.status,
        translations: [
          {
            title: item?.title,
            lang: "ko",
            contents: [
              {
                lang: "ko",
                content: item?.content || "",
                is_active: !!item?.status,
                device_screen_type: "MOBILE",
              },
              {
                lang: "ko",
                content: item?.content || "",
                is_active: !!item?.status,
                device_screen_type: "DESKTOP",
              },
              {
                lang: "ko",
                content: item?.content || "",
                is_active: !!item?.status,
                device_screen_type: "FOLD",
              },
            ],
          },
          {
            title: item?.title,
            lang: "en",
            contents: [
              {
                lang: "en",
                content: item?.content || "",
                is_active: !!item?.status,
                device_screen_type: "MOBILE",
              },
              {
                lang: "en",
                content: item?.content || "",
                is_active: !!item?.status,
                device_screen_type: "DESKTOP",
              },
              {
                lang: "en",
                content: item?.content || "",
                is_active: !!item?.status,
                device_screen_type: "FOLD",
              },
            ],
          },
        ],
      })) || [];

    const resources =
      values?.resource?.map((item: any) => ({
        description: item?.label,
        type: item?.type, // PREPARATION_MATERIAL / GUIDE_MATERIAL
        input_type: item?.input_type, // LINK / FILE
        url: item?.source_url,
      })) || [];
    console.log("values?.audition_role", values?.audition_role);

    const role_groups =
      values?.audition_role?.map((item: any) => {
        const obj = {
          field_id: values?.category,
          field_role_group_id: item?.field_role_group_id,
          total: parseInt(item?.quantity),
          id: item?.id,
          roles:
            item?.role_detail?.map((i: any) => {
              const tempRole = {
                gender: i?.gender?.toUpperCase(),
                title: i?.role_name,
                require_age: i?.isRequired,
                from_age: parseInt(i?.min_age) || null,
                to_age: parseInt(i?.max_age) || null,
                id: i?.id,
              };
              if (!i?.id) {
                delete tempRole.id;
              }
              return tempRole;
            }) || [],
        };
        if (!item?.id) {
          delete obj.id;
        }
        return obj;
      }) || [];
    const data = {
      company_id: values?.company,
      title: {
        translations: [
          {
            lang: "en",
            content: values?.title,
          },
          {
            lang: "ko",
            content: values?.title,
          },
        ],
      },

      contact_email: values?.email,
      contact_phone: values?.phone,
      display_contact_email: !values?.isHideEmail,
      display_contact_phone: !values?.isHidePhone,
      image_urls: values?.files?.map((item: any) => item?.url),
      thumbnail_url: values?.thumbnail_url
        ? values?.thumbnail_url?.map((item: any) => item?.url)?.[0]
        : "",
      performance_title: {
        translations: [
          {
            lang: "en",
            content: values?.performance_title,
          },
          {
            lang: "ko",
            content: values?.performance_title,
          },
        ],
      },
      venue: values?.venue + "",
      // Performance Period
      performance_start_date: values?.performance_period_start_date
        ? formatISOString(values?.performance_period_start_date)
        : null,
      performance_end_date: values?.performance_period_end_date
        ? formatISOString(values?.performance_period_end_date)
        : null,
      status: values?.status,
      is_active: values?.is_active,
      is_performance_date_expected: values?.is_performance_date_expected,
      is_rehearsal_date_expected: values?.is_rehearsal_date_expected,
      // Recruitment Details
      rehearsal_start_date: values?.rehearsal_period_start_date
        ? formatISOString(values?.rehearsal_period_start_date)
        : null,
      rehearsal_end_date: values?.rehearsal_period_end_date
        ? formatISOString(values?.rehearsal_period_end_date)
        : null,

      application_start_date: values?.apply_start
        ? formatISOString(values?.apply_start)
        : null,
      application_end_date: values?.apply_end
        ? formatISOString(values?.apply_end)
        : null,
      result_annc_date: values?.result_date
        ? formatISOString(values?.result_date)
        : null,
      // required
      sections,
      // required
      resources,
      // required
      role_groups,
    };
    console.log("data", data);

    try {
      setIsLoading((_prev) => true);
      const response: any = id
        ? await auditionApi.putAudition(id, data)
        : await auditionApi.postAudition(data);
      if (response?.data) {
        setIsLoading((_prev) => false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
        triggerRefresh && triggerRefresh();
      } else {
        setIsLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoading((_prev) => false);
      toast(`${error?.message || error || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const validationSchema = Yup.object({
    title: Yup.string().required(`${t("Title is required")}`),
    performance_title: Yup.string().required(
      `${t("Performance title is required")}`
    ),
    company: Yup.string().required(`${t("Company is required")}`),
    category: Yup.string().required(`${t("Category is required")}`),
    files: Yup.array()
      .required(t("Photos are required"))
      .min(1, t("At least one item is required")),
    resource: Yup.array()
      .of(
        Yup.object({
          type: Yup.string().required(t("Type is required")),
          label: Yup.string().required(t("Label is required")),
          input_type: Yup.string().required(t("Input type is required")),
          source_url: Yup.string().required(t("Source URL is required")),
        })
      )
      .min(1, t("At least one item is required")),
    audition_role: Yup.array()
      .test(
        "audition-role-required",
        t("At least one item is required"),
        function (value) {
          const { category } = this.parent;
          if (category) {
            return Array.isArray(value) && value.length > 0;
          }
          return true;
        }
      )
      .of(
        Yup.object().shape({
          field_role_group_id: Yup.string().required(t("Group is required")),
          quantity: Yup.number().required(t("Quantity is required")),
          role_detail: Yup.array()
            .test(
              "role-detail-required",
              t("At least one item is required"),
              function (value) {
                const { isDetail } = this.parent;
                if (isDetail) {
                  return Array.isArray(value) && value.length > 0;
                }
                return true;
              }
            )
            .of(
              Yup.object().shape({
                gender: Yup.string().required(t("Gender is required")),
                role_name: Yup.string().required(t("Role name is required")),
                min_age: Yup.number().when(
                  "isRequired",
                  ([isRequired], schema) => {
                    if (isRequired)
                      return Yup.string().required(t("Min age is required"));
                    return schema;
                  }
                ),
                max_age: Yup.number().when(
                  "isRequired",
                  ([isRequired], schema) => {
                    if (isRequired)
                      return Yup.string().required(t("Max age is required"));
                    return schema;
                  }
                ),
              })
            ),
        })
      )
      .min(1, t("At least one item is required")),
    content: Yup.array()
      .of(
        Yup.object({
          title: Yup.string().required(t("Title is required")),
          // desktop: Yup.string().required(t("Desktop is required")),
          // fold: Yup.string().required(t("Fold is required")),
          content: Yup.string().required(t("Mobile is required")),
        })
      )
      .min(1, t("At least one item is required")),
  });

  // const onUpdateAuditionRole = async () => {
  //   const apiList: any = [];
  //   try {
  //     const touchedFields = formik?.values?.audition_role?.map((item: any) => {
  //       const role_detail = item?.role_detail?.map((element: any) => {
  //         return {
  //           role_name: true,
  //           min_age: true,
  //           max_age: true,
  //           gender: true,
  //         };
  //       });
  //       return {
  //         field_role_group_id: true,
  //         quantity: true,
  //         role_detail,
  //       };
  //     });

  //     formik?.setTouched(
  //       {
  //         audition_role: touchedFields,
  //       },
  //       true
  //     );
  //     if (formik?.errors?.audition_role?.length) {
  //       return;
  //     }
  //     const field_id = formik?.values?.category;
  //     const default_audition_role = formik?.values?.default_audition_role;
  //     // console.log("default_audition_role", default_audition_role);
  //     formik?.values?.audition_role?.forEach((element, index) => {
  //       const temp: any = default_audition_role?.[element?.id];
  //       if (temp) {
  //         if (
  //           temp?.field_role_group_id !== element?.field_role_group_id ||
  //           temp?.quantity !== element?.quantity
  //         ) {
  //           const tempRoleGroup = {
  //             audition_id: id,
  //             field_id,
  //             field_role_group_id: element?.field_role_group_id,
  //             audition_role_group_id: element?.id,
  //             total: parseInt(element?.quantity),
  //             order: index + 1,
  //           };
  //           console.log("update group", tempRoleGroup);
  //           // updateRoleGroup(tempRoleGroup);
  //           apiList.push(auditionApi.patchRoleGroupAudition(tempRoleGroup));
  //         }
  //         if (temp?.isDetail !== element?.isDetail && !element?.isDetail) {
  //           Object.keys(temp?.role_detail)?.forEach((i: any) => {
  //             const role_body = {
  //               audition_id: id,
  //               audition_role_group_id: element?.id,
  //               audition_role_id: parseInt(i),
  //             };
  //             console.log("delete role", role_body);

  //             apiList.push(auditionApi.deleteRole(role_body));
  //           });
  //         } else {
  //           element?.role_detail?.forEach((i: any, indexrole: number) => {
  //             const role_temp: any = temp?.role_detail?.[i?.id];
  //             if (role_temp) {
  //               if (
  //                 role_temp?.role_name !== i?.role_name ||
  //                 role_temp?.min_age !== i?.min_age ||
  //                 role_temp?.max_age !== i?.max_age ||
  //                 role_temp?.gender !== i?.gender ||
  //                 role_temp?.isRequired !== i?.isRequired
  //               ) {
  //                 const body_role = {
  //                   audition_id: id,
  //                   audition_role_group_id: element?.id,
  //                   audition_role_id: i?.id,
  //                   order: index + 1,
  //                   role: {
  //                     gender: i?.gender?.toUpperCase(),
  //                     title: i?.role_name,
  //                     require_age: i?.isRequired,
  //                     from_age: parseInt(i?.min_age) || null,
  //                     to_age: parseInt(i?.max_age) || null,
  //                     order: indexrole + 1,
  //                   },
  //                 };
  //                 console.log("update role", body_role);
  //                 // updateRole(body_role);
  //                 apiList.push(auditionApi.patchRole(body_role));
  //               }
  //             } else {
  //               const body_role = {
  //                 audition_id: id,
  //                 audition_role_group_id: element?.id,
  //                 order: 1,
  //                 role: {
  //                   gender: i?.gender?.toUpperCase(),
  //                   title: i?.role_name,
  //                   require_age: i?.isRequired,
  //                   from_age: parseInt(i?.min_age) || null,
  //                   to_age: parseInt(i?.max_age) || null,
  //                   order: indexrole + 1,
  //                 },
  //               };
  //               console.log("add role", body_role);
  //               // addRole(body_role);
  //               apiList.push(auditionApi.postRole(body_role));
  //             }
  //           });
  //         }
  //       } else {
  //         const tempRoleGroup = {
  //           audition_id: id,
  //           field_id,
  //           field_role_group_id: element?.field_role_group_id,
  //           total: parseInt(element?.quantity),
  //           order: index + 1,
  //           roles:
  //             element?.role_detail?.map((i: any) => ({
  //               gender: i?.gender?.toUpperCase(),
  //               title: i?.role_name,
  //               require_age: i?.isRequired,
  //               from_age: parseInt(i?.min_age) || null,
  //               to_age: parseInt(i?.max_age) || null,
  //             })) || [],
  //         };
  //         console.log("add group", tempRoleGroup);

  //         // addRoleGroup(tempRoleGroup);
  //         apiList.push(auditionApi.postRoleGroupAudition(tempRoleGroup));
  //       }
  //     });

  //     formik?.values?.role_group_delete?.forEach((item: any) => {
  //       console.log("item", item);
  //       const body = {
  //         audition_id: id,
  //         audition_role_group_id: item?.id,
  //       };

  //       if (item?.isDelete) {
  //         console.log("delete group", body);
  //         // deleteRoleGroup(body);
  //         apiList.push(auditionApi.deleteRoleGroupAudition(body));
  //       }

  //       item?.role_details?.forEach((i: any) => {
  //         const role_body = {
  //           audition_id: id,
  //           audition_role_group_id: item?.id,
  //           audition_role_id: i,
  //         };
  //         console.log("delete role", role_body);

  //         // deleteRole(role_body);
  //         apiList.push(auditionApi.deleteRole(role_body));
  //       });
  //     });

  //     console.log("apiList", apiList);
  //     if (apiList?.length) {
  //       Promise.all(apiList)
  //         .then((res) => {
  //           console.log("res", res);
  //           toast(
  //             `${t("The process has been completed.")}`,
  //             CONFIG_OPTION_TOAST_NORMAL
  //           );
  //           triggerRefresh && triggerRefresh();
  //         })
  //         .catch((error) => {
  //           console.log("error", error);
  //           setIsLoading((_prev) => false);
  //           toast(`${error}`, CONFIG_OPTION_TOAST_ERROR);
  //         });
  //     } else {
  //       return;
  //     }
  //   } catch (error) {
  //     console.log("error1212", error);
  //   }
  // };

  const formik = useFormik({
    initialValues: {
      title: "",
      is_active: true,
      status: "DRAFT",
      performance_title: "",
      phone: "",
      email: "",
      venue: "",
      isSetup: true,
      isHidePhone: false,
      isHideEmail: false,
      company: "",
      category: "",
      apply_start: null,
      apply_end: null,
      performance_period_start_date: null,
      performance_period_end_date: null,
      is_performance_date_expected: false,
      rehearsal_period_start_date: null,
      rehearsal_period_end_date: null,
      is_rehearsal_date_expected: false,
      result_date: null,
      // role_group_delete: [],
      resource: [
        {
          id: 1,
          type: "",
          label: "",
          input_type: "FILE",
          source_url: "",
        },
      ] as any[],
      audition_role: [
        {
          idx: 1,
          group: "",
          field_role_group_id: "",
          quantity: "",
          isDetail: false,
          role_detail: [],
        },
      ],
      content: [
        {
          id: 1,
          title: "",
          desktop: "",
          fold: "",
          mobile: "",
          status: false,
        },
      ] as any[],
      files: null,
      thumbnail_url: null,
      // default_audition_role: [],
    },
    validationSchema,
    onSubmit: handleSubmit,
  });

  const handleSetValueForm = (value: any) => {
    console.log("valueDefault", value);
    const resource = value?.resources?.map((item: any) => ({
      id: item?.id,
      type: item?.type,
      label: item?.description,
      input_type: item?.input_type || "LINK",
      source_url: item?.url,
    }));

    const audition_role =
      value?.role_groups?.map((item: any, index: number) => {
        return {
          id: item?.id,
          idx: index + 1,
          group: item?.field_role_group?.title,
          field_role_group_id: item?.field_role_group?.id,
          quantity: item?.total,
          isDetail: !!item?.roles?.length,
          role_detail:
            item?.roles?.map((i: any, indexRole: number) => {
              return {
                id: i?.id,
                idx: indexRole + 1,
                role_name: i?.title,
                min_age: i?.from_age || "",
                max_age: i?.to_age || "",
                gender: i?.gender,
                isRequired: i?.require_age,
              };
            }) || [],
        };
      }) || [];

    // const temp = categories?.find(
    //   (item: any) => item?.id == event?.value
    // );
    // const role_groups = temp?.role_groups?.map(
    //   (item: any) => ({
    //     ...item,
    //     label: item?.title,
    //     value: item?.id,
    //   })
    // );

    const content =
      value?.sections
        .filter((i: any) => i?.lang === "en")
        ?.map((item: any) => ({
          id: item?.id,
          title: item?.title,
          content: item?.contents?.[0]?.content,
          // fold: item?.contents?.[2]?.content,
          // mobile: item?.contents?.[1]?.content,
          status: item?.is_active ? 1 : 0,
        })) || [];
    const data: any = {
      title: value?.title,
      is_active: value?.is_active,
      status: value?.status,
      performance_title: value?.performance?.title,
      phone: value?.contact_phone,
      email: value?.contact_email,
      venue: value?.performance?.venue,
      isSetup: !!(
        value?.result_annc_date ||
        value?.application_start_date ||
        value?.application_end_date
      ),
      isHidePhone: !value?.display_contact_phone,
      isHideEmail: !value?.display_contact_email,
      company: value?.company_id,
      category: value?.role_groups?.[0]?.field?.id,
      apply_start: value?.application_start_date
        ? new Date(formatDateStringToKorea(value?.application_start_date))
        : null,
      apply_end: value?.application_end_date
        ? new Date(formatDateStringToKorea(value?.application_end_date))
        : null,
      performance_period_start_date: value?.performance?.performance_start_date
        ? new Date(
            formatDateStringToKorea(value?.performance?.performance_start_date)
          )
        : null,
      performance_period_end_date: value?.performance?.performance_end_date
        ? new Date(
            formatDateStringToKorea(value?.performance?.performance_end_date)
          )
        : null,
      is_performance_date_expected:
        value?.performance?.is_performance_date_expected,
      rehearsal_period_start_date: value?.performance?.rehearsal_start_date
        ? new Date(
            formatDateStringToKorea(value?.performance?.rehearsal_start_date)
          )
        : null,
      rehearsal_period_end_date: value?.performance?.rehearsal_end_date
        ? new Date(
            formatDateStringToKorea(value?.performance?.rehearsal_end_date)
          )
        : null,
      is_rehearsal_date_expected:
        value?.performance?.is_rehearsal_date_expected,
      result_date: value?.result_annc_date
        ? new Date(formatDateStringToKorea(value?.result_annc_date))
        : null,
      resource,
      audition_role,
      content,
      files: value?.image_urls?.map((item: any) => ({ url: item })),
      thumbnail_url: value?.thumbnail_url
        ? [{ url: value?.thumbnail_url }]
        : "",
      // default_audition_role,
      // role_group_delete: [],
    };

    formik.setValues(data);
  };

  const handleCallBarDetail = async (idItem: string) => {
    try {
      if (!idItem) {
        return;
      }
      setIsLoadingDetail((_prev) => true);
      const resDetail: any = await auditionApi.getAudition(idItem);
      if (resDetail?.data) {
        handleSetValueForm(resDetail?.data);
        setIsLoadingDetail((_prev) => false);
      }
    } catch (error: any) {
      setIsLoadingDetail((_prev) => false);
      return error;
    }
  };

  const onCloseClick = () => {
    setIsOpen(false);
    setItemToEdit(false);
  };

  const getCategory = async (company_id: string) => {
    try {
      const response: any = await fieldsApi.getFields({ company_id });
      if (response?.data) {
        const result = response?.data?.items?.map((item: any) => ({
          ...item,
          label: item?.title,
          value: item?.id,
        }));
        setCategories(result);
        if (formik?.values?.category) {
          const temp = result?.find(
            (item: any) => item?.id == formik?.values?.category
          );
          const role_groups = temp?.role_groups?.map((item: any) => ({
            ...item,
            label: item?.title,
            value: item?.id,
          }));
          formik.setFieldValue("role_group", role_groups || []);
        }
      }
    } catch (error) {
      return error;
    }
  };

  useEffect(() => {
    if (formik?.values?.company) {
      getCategory(formik?.values?.company);
    }
  }, [formik?.values?.company]);

  useEffect(() => {
    const companyID = userProfile?.user?.company?.id;
    if (userPermissions === "COMPANY" && companyID) {
      formik.setFieldValue("company", companyID);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    handleCallBarDetail(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    document.title = `${t("Bar Create")} - ${t("Bars")} | ShowStar`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <Modal isOpen={true} centered={true} scrollable={true} size="xl">
        <ModalHeader toggle={isLoading ? () => {} : onCloseClick}>
          {id ? t("Update Audition") : t("Create Audition")}
        </ModalHeader>
        <ModalBody className="py-3 px-4">
          <div className="mb-4">
            <Progress
              value={
                100 - (100 / 2) * Number(Object.keys(formik.errors).length)
              }
              color="primary"
              className="animated-progress progress-sm"
            />
          </div>

          <div className="mt-3">
            <>
              {isLoadingDetail && (
                <div
                  style={{
                    position: "absolute",
                    zIndex: 3,
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                    backgroundColor: "rgb(164 164 164 / 36%)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Spinner size="sm" color="primary"></Spinner>
                </div>
              )}
              <form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col lg={12}>
                    <div className="mb-3">
                      <Label className="form-label">
                        {t("Audition Title")}{" "}
                        {/* <span className="text-danger">*</span> */}
                      </Label>
                      <Input
                        id="name-bar"
                        name="title"
                        type="text"
                        className="form-control"
                        placeholder={t("Enter the title")}
                        value={formik?.values?.title}
                        onChange={(event: any) =>
                          formik.setFieldValue("title", event?.target?.value)
                        }
                      />
                      {formik.touched.title && formik.errors.title ? (
                        <div className="text-danger mt-2">
                          {formik.errors.title}
                        </div>
                      ) : null}
                    </div>
                  </Col>

                  {userPermissions !== "COMPANY" && (
                    <Col lg={6}>
                      <div className="mb-3">
                        <Label className="form-label">{t("Company")}</Label>

                        <DropdownStatusNew
                          name="company"
                          dataList={COMPANIES}
                          placeholder={`${t("Select company")}...`}
                          className="dropdown-status-rounded"
                          classNamePrefix="name-prefix"
                          initialValue={formik?.values?.company || null}
                          onChangeSelect={(event: any) => {
                            formik.setFieldValue("category", "");
                            formik.setFieldValue("role_group", []);
                            formik.setFieldValue("company", event?.value);
                          }}
                          // colors={COLOR_BAR_LIST_PLAN}
                        />
                        {formik?.touched?.company && formik?.errors?.company ? (
                          <div className="text-danger mt-2">
                            {formik?.errors?.company}
                          </div>
                        ) : null}
                      </div>
                    </Col>
                  )}

                  <Col lg={6}>
                    <div className="mb-3">
                      <Label className="form-label">{t("Status")}</Label>

                      <DropdownStatusNew
                        name="status"
                        dataList={LIST_OPTION_AUDITION_STATUS}
                        placeholder={`${t("Select status")}...`}
                        className="dropdown-status-rounded"
                        classNamePrefix="name-prefix"
                        initialValue={formik?.values?.status || null}
                        onChangeSelect={(event: any) =>
                          formik.setFieldValue("status", event?.value)
                        }
                        optionHide={!!id ? [] : ["CLOSED"]}
                        colors={COLOR_AUDITION_STATUS}
                      />
                      {formik?.touched?.status && formik?.errors?.status ? (
                        <div className="text-danger mt-2">
                          {formik?.errors?.status}
                        </div>
                      ) : null}
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Label className="form-label">{t("Category")}</Label>

                      <DropdownStatusNew
                        name="category"
                        dataList={categories}
                        placeholder={`${t("Select category")}...`}
                        className="dropdown-status-rounded"
                        classNamePrefix="name-prefix"
                        initialValue={formik?.values?.category || null}
                        onChangeSelect={(event: any) => {
                          if (
                            formik?.values?.audition_role?.[0]
                              ?.field_role_group_id ||
                            formik?.values?.audition_role?.[0]?.quantity ||
                            formik?.values?.audition_role?.[0]?.isDetail
                          ) {
                            setIsOpenConfirm(event?.value);
                          } else {
                            const temp = categories?.find(
                              (item: any) => item?.id == event?.value
                            );
                            const role_groups = temp?.role_groups?.map(
                              (item: any) => ({
                                ...item,
                                label: item?.title,
                                value: item?.id,
                              })
                            );

                            formik.setFieldValue(
                              "role_group",
                              role_groups || []
                            );
                            formik.setFieldValue("category", event?.value);
                          }
                        }}
                        // colors={COLOR_BAR_LIST_PLAN}
                      />
                      {formik?.touched?.category && formik?.errors?.category ? (
                        <div className="text-danger mt-2">
                          {formik?.errors?.category}
                        </div>
                      ) : null}
                    </div>
                  </Col>

                  <Col lg={6}>
                    <div className="mb-3">
                      <Label className="form-label">{t("Active")}</Label>
                      <div className="form-check form-switch mb-0 mt-0 mb-3">
                        <Input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="is_active"
                          name="is_active"
                          checked={!!formik?.values?.is_active}
                          onChange={(event: any) =>
                            formik.setFieldValue(
                              "is_active",
                              event?.target.checked
                            )
                          }
                        />
                      </div>

                      {formik?.touched?.is_active &&
                      formik?.errors?.is_active ? (
                        <div className="text-danger mt-2">
                          {formik?.errors?.is_active}
                        </div>
                      ) : null}
                    </div>
                  </Col>

                  <Col xxl={12}>
                    <div className="mb-3">
                      <label className="form-label">
                        {t("Thumbnail")}
                        {/* <span className="text-danger"> *</span> */}
                      </label>
                      <UploadImage
                        data={formik.getFieldProps("thumbnail_url")?.value}
                        maxCount={1}
                        //setLinkImage={setLinkImage}
                        formik={formik}
                        isMultiple={false}
                        formikNameImage="thumbnail_url"
                      />

                      {formik.errors.thumbnail_url ? (
                        <div className="text-danger mt-2">
                          {formik.errors.thumbnail_url}
                        </div>
                      ) : null}
                    </div>
                  </Col>

                  <Col xxl={12}>
                    <div className="mb-3">
                      <label className="form-label">{t("Photos")}</label>
                      <UploadImage
                        data={formik.getFieldProps("files")?.value}
                        setLinkImage={setLinkImage}
                        formik={formik}
                        formikNameImage="files"
                      />
                    </div>
                  </Col>
                  <div
                    className="position-relative mb-3 mt-3 mt-md-3"
                    style={{
                      border: "1px dashed var(--vz-primary)",
                      borderRadius: "4px",
                      padding: "10px",
                    }}
                  >
                    <span
                      className="text-primary position-absolute fs-13 px-1"
                      style={{
                        backgroundColor: "var(--vz-secondary-bg)",
                        top: "0px",
                        transform: "translateY(-50%)",
                      }}
                    >
                      {t("Audition Role")}
                    </span>
                    <AuditionRoleFormArray
                      formik={formik}
                      // id={id}
                      // onUpdate={onUpdateAuditionRole}
                    />
                  </div>

                  <div
                    className="position-relative mb-3 mt-3 mt-md-3"
                    style={{
                      border: "1px dashed var(--vz-primary)",
                      borderRadius: "4px",
                      padding: "10px",
                    }}
                  >
                    <span
                      className="text-primary position-absolute fs-13 px-1"
                      style={{
                        backgroundColor: "var(--vz-secondary-bg)",
                        top: "0px",
                        transform: "translateY(-50%)",
                      }}
                    >
                      {t("Recruitment Details")}
                    </span>
                    <Row>
                      <Col lg={12}>
                        <div className="mb-3 mt-1">
                          <Label className="form-label">
                            {t("Performance Title")}{" "}
                            {/* <span className="text-danger">*</span> */}
                          </Label>
                          <Input
                            id="name-bar"
                            name="performance_title"
                            type="text"
                            className="form-control"
                            placeholder={t("Enter the performance title")}
                            value={formik?.values?.performance_title}
                            onChange={(event: any) =>
                              formik.setFieldValue(
                                "performance_title",
                                event?.target?.value
                              )
                            }
                          />
                          {formik.touched.performance_title &&
                          formik.errors.performance_title ? (
                            <div className="text-danger mt-2">
                              {formik.errors.performance_title}
                            </div>
                          ) : null}
                        </div>
                      </Col>

                      <Col lg={6}>
                        <div className="mb-3">
                          <Label className="form-label">{t("Venue")}</Label>
                          <Input
                            id="name-bar"
                            name="venue"
                            type="text"
                            className="form-control"
                            placeholder={t("Enter the venue")}
                            value={formik?.values?.venue}
                            onChange={(event: any) =>
                              formik.setFieldValue(
                                "venue",
                                event?.target?.value
                              )
                            }
                          />
                          {formik.touched.venue && formik.errors.venue ? (
                            <div className="text-danger mt-2">
                              {formik.errors.venue}
                            </div>
                          ) : null}
                        </div>
                      </Col>
                      <Col lg={6} />
                      <Col lg={6}>
                        <div className="mb-3">
                          <Label className="form-label">
                            {t("Performance Period")}
                          </Label>

                          <Row>
                            <Col lg={6}>
                              <div className="mb-3">
                                <Label className="form-label">
                                  {t("Start Date")}
                                </Label>

                                <div className="w-100">
                                  <DatePicker
                                    name={"performance_period_start_date"}
                                    className="form-control"
                                    selected={
                                      formik?.values
                                        ?.performance_period_start_date
                                    }
                                    placeholderText={`${t("Select Date")}`}
                                    onChange={(date: any) => {
                                      formik.setFieldValue(
                                        "performance_period_start_date",
                                        date || ""
                                      );
                                    }}
                                    disabled={isShowDetail}
                                    locale={"ko"}
                                    popperPlacement="auto"
                                    wrapperClassName="w-100"
                                    dateFormat="yyyy-MM-dd HH:mm:ss"
                                    showTimeSelect
                                  />
                                </div>

                                {formik?.touched
                                  ?.performance_period_start_date &&
                                formik?.errors
                                  ?.performance_period_start_date ? (
                                  <div className="text-danger mt-2">
                                    {
                                      formik?.errors
                                        ?.performance_period_start_date
                                    }
                                  </div>
                                ) : null}
                              </div>
                            </Col>

                            <Col lg={6}>
                              <div className="mb-3">
                                <Label className="form-label">
                                  {t("End Date")}
                                </Label>

                                <div className="w-100">
                                  <DatePicker
                                    name={"performance_period_end_date"}
                                    className="form-control"
                                    selected={
                                      formik?.values
                                        ?.performance_period_end_date
                                    }
                                    placeholderText={`${t("Select Date")}`}
                                    onChange={(date: any) => {
                                      formik.setFieldValue(
                                        "performance_period_end_date",
                                        date || ""
                                      );
                                    }}
                                    disabled={isShowDetail}
                                    locale={"ko"}
                                    popperPlacement="auto"
                                    wrapperClassName="w-100"
                                    dateFormat="yyyy-MM-dd HH:mm:ss"
                                    showTimeSelect
                                  />
                                </div>

                                {formik?.touched?.performance_period_end_date &&
                                formik?.errors?.performance_period_end_date ? (
                                  <div className="text-danger mt-2">
                                    {
                                      formik?.errors
                                        ?.performance_period_end_date
                                    }
                                  </div>
                                ) : null}
                              </div>
                            </Col>
                          </Row>
                          <div className="form-check form-switch mb-0 mt-0 mb-3">
                            <Input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="is_performance_date_expected"
                              name="is_performance_date_expected"
                              checked={
                                !!formik?.values?.is_performance_date_expected
                              }
                              onChange={(event: any) =>
                                formik.setFieldValue(
                                  "is_performance_date_expected",
                                  event?.target.checked
                                )
                              }
                            />

                            <Label
                              className="form-check-label"
                              for="is_performance_date_expected"
                            >
                              {t("Tentative")}
                            </Label>
                          </div>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="mb-3">
                          <Label className="form-label">
                            {t("Rehearsal Period")}
                          </Label>

                          <Row>
                            <Col lg={6}>
                              <div className="mb-3">
                                <Label className="form-label">
                                  {t("Start Date")}
                                </Label>

                                <div className="w-100">
                                  <DatePicker
                                    name={"rehearsal_period_start_date"}
                                    className="form-control"
                                    selected={
                                      formik?.values
                                        ?.rehearsal_period_start_date
                                    }
                                    placeholderText={`${t("Select Date")}`}
                                    onChange={(date: any) => {
                                      formik.setFieldValue(
                                        "rehearsal_period_start_date",
                                        date || ""
                                      );
                                    }}
                                    disabled={isShowDetail}
                                    locale={"ko"}
                                    popperPlacement="auto"
                                    wrapperClassName="w-100"
                                    dateFormat="yyyy-MM-dd HH:mm:ss"
                                    showTimeSelect
                                  />
                                </div>

                                {formik?.touched?.rehearsal_period_start_date &&
                                formik?.errors?.rehearsal_period_start_date ? (
                                  <div className="text-danger mt-2">
                                    {
                                      formik?.errors
                                        ?.rehearsal_period_start_date
                                    }
                                  </div>
                                ) : null}
                              </div>
                            </Col>

                            <Col lg={6}>
                              <div className="mb-3">
                                <Label className="form-label">
                                  {t("End Date")}
                                </Label>

                                <div className="w-100">
                                  <DatePicker
                                    name={"rehearsal_period_end_date"}
                                    className="form-control"
                                    selected={
                                      formik?.values?.rehearsal_period_end_date
                                    }
                                    placeholderText={`${t("Select Date")}`}
                                    onChange={(date: any) => {
                                      formik.setFieldValue(
                                        "rehearsal_period_end_date",
                                        date || ""
                                      );
                                    }}
                                    disabled={isShowDetail}
                                    locale={"ko"}
                                    popperPlacement="auto"
                                    wrapperClassName="w-100"
                                    dateFormat="yyyy-MM-dd HH:mm:ss"
                                    showTimeSelect
                                  />
                                </div>

                                {formik?.touched?.rehearsal_period_end_date &&
                                formik?.errors?.rehearsal_period_end_date ? (
                                  <div className="text-danger mt-2">
                                    {formik?.errors?.rehearsal_period_end_date}
                                  </div>
                                ) : null}
                              </div>
                            </Col>
                          </Row>

                          <div className="form-check form-switch mb-0 mt-0 mb-3">
                            <Input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="is_rehearsal_date_expected"
                              name="is_rehearsal_date_expected"
                              checked={
                                !!formik?.values?.is_rehearsal_date_expected
                              }
                              onChange={(event: any) =>
                                formik.setFieldValue(
                                  "is_rehearsal_date_expected",
                                  event?.target.checked
                                )
                              }
                            />

                            <Label
                              className="form-check-label"
                              for="is_rehearsal_date_expected"
                            >
                              {t("Tentative")}
                            </Label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <div
                    className="position-relative mb-3 mt-3 mt-md-3"
                    style={{
                      border: "1px dashed var(--vz-primary)",
                      borderRadius: "4px",
                      padding: "10px",
                    }}
                  >
                    <span
                      className="text-primary position-absolute fs-13 px-1"
                      style={{
                        backgroundColor: "var(--vz-secondary-bg)",
                        top: "0px",
                        transform: "translateY(-50%)",
                      }}
                    >
                      {t("Registration information")}
                    </span>
                    <Row>
                      <Col lg={4}>
                        <div className="d-flex h-100 align-items-end mt-1">
                          <div className="form-check mb-0 mt-0 mb-3">
                            <Input
                              className=""
                              type="radio"
                              id="isSetup"
                              name="isSetup"
                              checked={!!formik?.values?.isSetup}
                              onChange={(event: any) =>
                                formik.setFieldValue("isSetup", true)
                              }
                            />

                            <Label className="form-check-label" for="isSetup">
                              {t("Set application period")}
                            </Label>
                          </div>
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div className="d-flex h-100 align-items-end">
                          <div className="form-check mb-0 mt-0 mb-3">
                            <Input
                              className=""
                              type="radio"
                              id="isSetup"
                              name="isSetup"
                              checked={!formik?.values?.isSetup}
                              onChange={(event: any) => {
                                formik.setFieldValue("result_date", null);
                                formik.setFieldValue("apply_start", null);
                                formik.setFieldValue("apply_end", null);
                                formik.setFieldValue("isSetup", false);
                              }}
                            />

                            <Label className="form-check-label" for="isSetup">
                              {t("No setup")}
                            </Label>
                          </div>
                        </div>
                      </Col>
                      <Col lg={4} />

                      {!!formik?.values?.isSetup && (
                        <React.Fragment>
                          <Col lg={4}>
                            <div className="mb-3">
                              <Label className="form-label">
                                {t("Start Date")}
                              </Label>

                              <div className="w-100">
                                <DatePicker
                                  name={"apply_start"}
                                  className="form-control"
                                  selected={formik?.values?.apply_start}
                                  placeholderText={`${t("Select Date")}`}
                                  onChange={(date: any) => {
                                    formik.setFieldValue(
                                      "apply_start",
                                      date || ""
                                    );
                                  }}
                                  disabled={isShowDetail}
                                  locale={"ko"}
                                  popperPlacement="auto"
                                  wrapperClassName="w-100"
                                  dateFormat="yyyy-MM-dd HH:mm:ss"
                                  showTimeSelect
                                />
                              </div>

                              {formik?.touched?.apply_start &&
                              formik?.errors?.apply_start ? (
                                <div className="text-danger mt-2">
                                  {formik?.errors?.apply_start}
                                </div>
                              ) : null}
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div className="mb-3">
                              <Label className="form-label">
                                {t("End Date")}
                              </Label>

                              <div className="w-100">
                                <DatePicker
                                  name={"apply_end"}
                                  className="form-control"
                                  selected={formik?.values?.apply_end}
                                  placeholderText={`${t("Select Date")}`}
                                  onChange={(date: any) => {
                                    formik.setFieldValue(
                                      "apply_end",
                                      date || ""
                                    );
                                  }}
                                  disabled={isShowDetail}
                                  locale={"ko"}
                                  popperPlacement="auto"
                                  wrapperClassName="w-100"
                                  dateFormat="yyyy-MM-dd HH:mm:ss"
                                  showTimeSelect
                                />
                              </div>

                              {formik?.touched?.apply_end &&
                              formik?.errors?.apply_end ? (
                                <div className="text-danger mt-2">
                                  {formik?.errors?.apply_end}
                                </div>
                              ) : null}
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div className="mb-3">
                              <Label className="form-label">
                                {t("Result Date")}
                              </Label>

                              <div className="w-100">
                                <DatePicker
                                  name={"result_date"}
                                  className="form-control"
                                  selected={formik?.values?.result_date}
                                  placeholderText={`${t("Select Date")}`}
                                  onChange={(date: any) => {
                                    formik.setFieldValue(
                                      "result_date",
                                      date || ""
                                    );
                                  }}
                                  disabled={isShowDetail}
                                  locale={"ko"}
                                  popperPlacement="auto"
                                  wrapperClassName="w-100"
                                  dateFormat="yyyy-MM-dd HH:mm:ss"
                                  showTimeSelect
                                />
                              </div>

                              {formik?.touched?.result_date &&
                              formik?.errors?.result_date ? (
                                <div className="text-danger mt-2">
                                  {formik?.errors?.result_date}
                                </div>
                              ) : null}
                            </div>
                          </Col>
                        </React.Fragment>
                      )}

                      <Col lg={4}>
                        <div className="mb-3">
                          <Label className="form-label">
                            {t("Contact Phone")}
                          </Label>
                          <Input
                            id="name-bar"
                            name="phone"
                            type="text"
                            className="form-control"
                            placeholder={t("Enter the phone")}
                            value={formik?.values?.phone}
                            onChange={(event: any) =>
                              formik.setFieldValue(
                                "phone",
                                event?.target?.value
                              )
                            }
                          />{" "}
                          <div className="form-check form-switch mb-0 mt-3 mb-3">
                            <Input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="isHidePhone"
                              name="isHidePhone"
                              checked={!!formik?.values?.isHidePhone}
                              onChange={(event: any) =>
                                formik.setFieldValue(
                                  "isHidePhone",
                                  event?.target.checked
                                )
                              }
                            />

                            <Label
                              className="form-check-label"
                              for="isHidePhone"
                            >
                              {t("Hide")}
                            </Label>
                          </div>
                          {formik.touched.phone && formik.errors.phone ? (
                            <div className="text-danger mt-2">
                              {formik.errors.phone}
                            </div>
                          ) : null}
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div className="mb-3">
                          <Label className="form-label">
                            {t("Contact Email")}
                          </Label>
                          <Input
                            id="name-bar"
                            name="email"
                            type="text"
                            className="form-control"
                            placeholder={t("Enter the email")}
                            value={formik?.values?.email}
                            onChange={(event: any) =>
                              formik.setFieldValue(
                                "email",
                                event?.target?.value
                              )
                            }
                          />
                          <div className="form-check form-switch mb-0 mt-3 mb-3">
                            <Input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="isHideEmail"
                              name="isHideEmail"
                              checked={!!formik?.values?.isHideEmail}
                              onChange={(event: any) =>
                                formik.setFieldValue(
                                  "isHideEmail",
                                  event?.target.checked
                                )
                              }
                            />

                            <Label
                              className="form-check-label"
                              for="isHideEmail"
                            >
                              {t("Hide")}
                            </Label>
                          </div>
                          {formik.touched.email && formik.errors.email ? (
                            <div className="text-danger mt-2">
                              {formik.errors.email}
                            </div>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <div
                    className="position-relative mb-3 mt-3 mt-md-3"
                    style={{
                      border: "1px dashed var(--vz-primary)",
                      borderRadius: "4px",
                      padding: "10px",
                    }}
                  >
                    <span
                      className="text-primary position-absolute fs-13 px-1"
                      style={{
                        backgroundColor: "var(--vz-secondary-bg)",
                        top: "0px",
                        transform: "translateY(-50%)",
                      }}
                    >
                      {t("Content")}
                    </span>
                    <ContentDetailFormArray formik={formik} />
                  </div>

                  <div
                    className="position-relative mb-3 mt-3 mt-md-3"
                    style={{
                      border: "1px dashed var(--vz-primary)",
                      borderRadius: "4px",
                      padding: "10px",
                    }}
                  >
                    <span
                      className="text-primary position-absolute fs-13 px-1"
                      style={{
                        backgroundColor: "var(--vz-secondary-bg)",
                        top: "0px",
                        transform: "translateY(-50%)",
                      }}
                    >
                      {t("Audition Resource")}
                    </span>
                    <ResourceFormArray formik={formik} />
                  </div>

                  <Col lg={12}>
                    <div className="hstack gap-2 justify-content-end">
                      {!isShowDetail && (
                        <button type="submit" className="btn btn-primary fs-14">
                          {isLoading ? (
                            <Spinner size="sm" className="me-2"></Spinner>
                          ) : !!id ? (
                            <i className="ri-login-circle-line align-bottom me-2 "></i>
                          ) : (
                            <i className="ri-add-fill align-bottom me-2"></i>
                          )}
                          {id
                            ? t("Button Update Audition")
                            : t("Button Create Audition")}
                        </button>
                      )}
                    </div>
                  </Col>
                </Row>
                <ModalConfirm
                  header={t("Change category")}
                  title={t("Delete Audition Role")}
                  content={t(
                    "When you change categories, all current audition roles will be deleted."
                  )}
                  isOpen={isOpenConfirm}
                  onClose={onCloseConfirmClick}
                  onConfirm={handleConfirmCategory}
                />
              </form>
            </>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default AuditionForm;
